import React, { useCallback, useState } from 'react';
import { Link } from 'react-router-dom';
import Component from '../../components/Component';
import AnalyticsTab from './AnalyticsTab';
import LeagueControlsTab from './LeagueControlsTab';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import {
  Alert,
  Box,
  Button,
  Card,
  CardContent,
  Snackbar,
  Tab,
  Tabs,
  Typography,
} from '@mui/material';

function MindCricketLeague() {
  const [tab, setTab] = useState(0);
  const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'success' });

  const showSnackbar = useCallback((message, severity = 'success') => {
    setSnackbar({ open: true, message, severity });
  }, []);

  const onSessionExpired = useCallback(
    (res) => {
      if (String(res?.statusCode || '') === '10003') {
        showSnackbar('Session expired. Please login again.', 'error');
        setTimeout(() => {
          window.location = '/login';
        }, 1500);
        return true;
      }
      return false;
    },
    [showSnackbar]
  );

  return (
    <Component>
      <div className="page-body">
        <div className="container-fluid">
          <div className="page-header">
            <div className="row align-items-center">
              <div className="col-sm-8">
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                  <Button
                    component={Link}
                    to="/admin/arcade"
                    startIcon={<ArrowBackIcon />}
                    size="small"
                  >
                    Arcade
                  </Button>
                  <h3 style={{ margin: 0 }}>Mind Cricket + Super Over League</h3>
                </Box>
                <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5, ml: 1 }}>
                  Analytics for Mind Cricket / League play, and controls for league economy &amp;
                  levels.
                </Typography>
              </div>
            </div>
          </div>
        </div>

        <div className="container-fluid">
          <div className="row">
            <div className="col-sm-12">
              <Card>
                <CardContent>
                  <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: 2 }}>
                    <Tabs value={tab} onChange={(_, v) => setTab(v)}>
                      <Tab label="Analytics" />
                      <Tab label="League Controls" />
                    </Tabs>
                  </Box>
                  {tab === 0 && (
                    <AnalyticsTab
                      onSessionExpired={onSessionExpired}
                      showSnackbar={showSnackbar}
                    />
                  )}
                  {tab === 1 && (
                    <LeagueControlsTab
                      onSessionExpired={onSessionExpired}
                      showSnackbar={showSnackbar}
                    />
                  )}
                </CardContent>
              </Card>
            </div>
          </div>
        </div>
      </div>

      <Snackbar
        open={snackbar.open}
        autoHideDuration={4000}
        onClose={() => setSnackbar((s) => ({ ...s, open: false }))}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      >
        <Alert
          severity={snackbar.severity}
          onClose={() => setSnackbar((s) => ({ ...s, open: false }))}
          variant="filled"
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </Component>
  );
}

export default MindCricketLeague;
